// const backendDomain = "https://stationary-ecommerce-backend-ten.vercel.app"
const backendDomain = "https://ecommerce-backend-three-ashen.vercel.app"; 
//const backendDomain = "http://localhost:8000"

const SummaryApi = {
    signUp : {
        url : `${backendDomain}/api/signup`,
        method : "POST",
    },
    signIn : {
        url : `${backendDomain}/api/signin`,
        method : "POST",
    },
    current_user : {
        url : `${backendDomain}/api/user-details`,
        method : "GET",
    },
    logout_user : {
        url : `${backendDomain}/api/userLogout`,
        method : "GET",
    },
    allUser : {
        url : `${backendDomain}/api/all-user`,
        method : "GET",
    },
    updateUser : {
        url : `${backendDomain}/api/update-user`,
        method : "POST"
    },
    uploadProduct : {
        url : `${backendDomain}/api/upload-product`,
        method : "POST"
    },
    allProduct : {
        url : `${backendDomain}/api/get-product`,
        method : "GET"
    },
    updateProduct : {
        url : `${backendDomain}/api/update-product`,
        method : "POST"
    },
    categoryProduct : {
        url : `${backendDomain}/api/get-categoryProduct`,
        method : "GET"
    },
    categoryWiseProduct : {
        url : `${backendDomain}/api/category-product`,
        method : "POST"
    },
    productDetails : {
        url : `${backendDomain}/api/product-details`,
        method : "POST"
    },
    addToCartProduct : {
        url : `${backendDomain}/api/cart/addtocart`,
        method : "POST"
    },
    addToCartProductCount : {
        url : `${backendDomain}/api/countAddToCartProduct`,
        method : "GET"
    },
    addToCartProductView : {
        url : `${backendDomain}/api/view-card-product`,
        method : "GET"
    },
    updateCartProduct : {
        url : `${backendDomain}/api/update-cart-product`,
        method : "POST"
    },
    deleteCartProduct : {
        url : `${backendDomain}/api/delete-cart-product`,
        method : "POST"
    },
    searchProduct : {
        url : `${backendDomain}/api/search`,
        method : "GET"
    },
    filterProduct : {
        url : `${backendDomain}/api/filter-product`,
        method : "POST"
    },
    createOrder : {
        url : `${backendDomain}/api/payment/create-order`,
        method : "POST"
    },
    verifyOrder : {
        url : `${backendDomain}/api/payment/verify`,
        method : "POST"
    },
    getAllOrders: {
        url: `${backendDomain}/api/orders`,
        method: "GET"
    },
    clearCart: { 
        url: `${backendDomain}/api/cart/clear`, 
        method: "POST"
    },
    deleteUser: (id) => ({
        url: `${backendDomain}/api/delete-user/${id}`,
        method: "DELETE"
    }),
    generateInvoice: (orderId) => ({
        url: `${backendDomain}/api/invoice/${orderId}`,
        method: "GET"
    }),
    forgotPassword: {
        url: `${backendDomain}/api/auth/forgot-password`,
        method: "POST"
    },
    resetPassword: {
        url: `${backendDomain}/api/auth/reset-password`,
        method: "POST"
    },
    deleteProduct: (id) => ({
        url: `${backendDomain}/api/delete-product/${id}`,
        method: "DELETE"
    }),



  
    getOrderById: (id) => `${backendDomain}/api/orders/${id}`,
    getUserOrders: (userId) => `${backendDomain}/api/orders/user/${userId}`,
    updateOrderStatus: (id) => `${backendDomain}/api/orders/${id}/status`          
          
};

export default SummaryApi;